<template>
    <section class="mine-page index-page">
        <wjs-header :class="isTop ? 'home_top':'home_noTop'" :configList="configList" v-if="configList"></wjs-header>
        <!-- 主面板Swiper -->
        <div v-if="bannerList">
            <top-swiper v-if="bannerList.length > 0 && device == 'web'"
                @show-detail="SetCininfoStatusFn(true)"
                :bannerList="bannerList"
                :homeLists="homeLists"
            ></top-swiper>
            <top-swiper v-if="bannerList.length > 0 && device == 'mob' && firstEnter"
                        @show-detail="SetCininfoStatusFn(true)"
                        :bannerList="bannerList"
                        :homeLists="homeLists"
            ></top-swiper>
        </div>
        <div v-if="device == 'web'" class="home-container hf">
          <template v-for="(item, index) in barList">
            <bar-movie  :key="index" v-if="fetchTimes == barList.length" :title="item.name" :lists="filterMovies(item.id)" :isBar="false"
            ></bar-movie>
          </template>
        </div>
        <div v-if="device == 'mob'" class="h-v-b">
          <div class="t-v-b">
            <p class="line"></p>
            <p class="t-v">TOP VIDEO</p>
          </div>
          <ul class="h5_ctn">
            <li v-for="(item, index) in mobMovieLists" :key="index"
                @click="linksToDetailHandler(item.movieInfo.id, item.movieInfo.member_type)"
            >
              <div class="h5_box" v-if="firstEnter">
                <span class="subscript-tag" v-if="item.movieInfo.is_subscript == 1"></span>
                <Servideo :videos="item.poster_img" :url="item.preview_url" :item="item" :indx="index" :tabIndex="tabIndex" v-if="item.preview_url.indexOf('m3u8') !== -1"></Servideo>
              </div>
              <div class="t-a-b clearfix">
                <p class="pull-left">
                  <i class="ex-i"></i>
                  <span class="s-ex">EXCLUSIVE</span>
                </p>
                <p class="pull-right">
                  <i class="play-i"></i>
                  <span class="s-am">{{ computedAmount(item.movieInfo.main_browse_num) }}</span>
                </p>
              </div>
              <p class="h-p-p">{{ item.movieInfo.name }}</p>
            </li>
          </ul>
          <p class="load-text">
            {{ isEnd ? $t("home.8") : $t("home.9") }}
          </p>
        </div>
        <midBar :configLists="configList" v-if="configList"></midBar>
        <!-- 影片详情 -->
        <transition
            enter-active-class="animated zoomIn" leave-active-class="animated fadeOut"
        >
            <cinema-detail v-if="cininfoStatus" style="animation-duration: 400ms;"></cinema-detail>
        </transition>
        <!-- 影片详情H5效果 -->
        <section v-if="cininfoStatusH5" class="background-bj" @touchmove.prevent></section>
            <transition
                enter-active-class="animated slideInUp" leave-active-class="animated slideOutDown"
            >
                <cinema-detail v-if="cininfoStatusH5" style="animation-duration: 400ms;"></cinema-detail>
            </transition>
        </section>
</template>

<script>
import { mapState, mapActions } from "vuex";
import WjsHeader from "@/components/Common/WjsHeader";
import TopSwiper from "@/components/Home/TopSwiper";
import CinemaList from "@/components/Home/CinemaList";
import CinemaHot from "@/components/Home/CinemaHot";
import CinemaDetail from "@/components/Home/CinemaDetail";
import BarMovie from "@/components/Home/BarMovie";
import Servideo from "@/components/Serial/Servideo2.vue"
import midBar from "@/components/Home/Midbar.vue"
export default {
    name: "Home",
    data(){
        return {
            hsctrl: false,
            isTop: false,
            blMovies: [],
            fetchTimes: 0,
            isEnd: false,
            isLoading: false,
            params: { page: 1, pageSize: 10 },
            isvis: false,
            tabIndex: 0,
        }
    },
    computed: {
        ...mapState({
            cininfoStatus: (state) => state.account.cininfoStatus,
            homeLists: (state) => state.home.homeLists,
            bannerList: (state) => state.home.bannerList,
            barList: (state) => state.home.barList,
            token: (state) => state.account.token,
            cininfoStatusH5: (state) => state.account.cininfoStatusH5,
            mobMovieLists: (state) => state.home.mobMovieLists,
            userMember: (state) => state.home.userMember,
            firstEnter: (state) => state.home.firstEnter,
            configList: (state) => state.home.configList,
        }),
        filterMovies(){
            return function(id){
                const mvArray = this.blMovies.filter(item => {
                    return item.tab_bar_id == id;
                });
                return mvArray;
            }
        },
        computedAmount(){
            return function(amount){

                let playAmt = parseInt(amount);

                if(amount < 1000) playAmt = amount;
                if(amount >=1000 && amount <= 100000) playAmt = (parseInt(amount) / 1000).toFixed(2) + 'K';
                if(amount >= 1000000) playAmt = (parseInt(amount) / 1000000).toFixed(2) + 'M';

                return playAmt;
            }
        }
    },
    async mounted(){
        this.SetLoadStatusFn({loadStatus: true});
        // Banner列表
        const bnParams = {page: 1, pageSize: 5};
        const bnResult = await this.FetchBannerListFn(bnParams);
        const adParams = {end_side:2};
        const adResult = await this.FetchConfadlistFn(adParams);
        if(this.device == 'mob'){

            const result = await this.FetchMobHomeMovieFn(
                this.params
            );

            console.log(this.mobMovieLists);

            this.SetLoadStatusFn({loadStatus: false});

            window.addEventListener('scroll', this.scrollMoreMovies, true);
        }

        if(this.device == 'web') {
          // 近期浏览
          if (this.token) {
            const hsParams = { page: 1, pageSize: 12 };
            const hsResult = await this.FetchHomeSeenFn(hsParams);
          }
          ;

          // UMovie列表
          const umParams = { type: 2, page: 1, pageSize: 24 };
          const umResult = await this.FetchUmovieListFn(umParams);

          // 最新上架
          const nmParams = { type: 1, page: 1, pageSize: 24 };
          const nmResult = await this.FetchNewMovieListFn(nmParams);

          this.hsctrl = true;
          this.SetLoadStatusFn({ loadStatus: false });

          // 获取自定义栏目列表
          const blResult = await this.FetchBarListsFn();

          for(const item of this.barList){
            const bmResult = await this.FetchBarMovieFn({
              id: item.id,
              page: 1,
              pageSize: 24
            });
            this.fetchTimes++;
            this.blMovies.push(...bmResult);
          }
        }

        if(this.device == 'web'){
            window.addEventListener('scroll',this.topscrollTo,true);
        }

    },
    destroyed () {
        if(this.device == 'web'){
            window.removeEventListener('scroll', this.topscrollTo, true);
        };

        if(this.device == 'mob'){
            window.removeEventListener('scroll', this.scrollMoreMovies, true);
        }
    },
    methods: {
        ...mapActions({
            SetLoadStatusFn: "SetLoadStatusFn",
            SetCininfoStatusFn: "SetCininfoStatusFn",
            FetchHomeSeenFn: "FetchHomeSeenFn",
            FetchUmovieListFn: "FetchUmovieListFn",
            FetchNewMovieListFn: "FetchNewMovieListFn",
            FetchBannerListFn: "FetchBannerListFn",
            FetchBarListsFn: "FetchBarListsFn",
            FetchBarMovieFn: "FetchBarMovieFn",
            FetchMobHomeMovieFn: "FetchMobHomeMovieFn",
            SetCininfoStatusH5Fn: "SetCininfoStatusH5Fn",
            getDataNikkatsuFn: "getDataNikkatsuFn",
            SetSiginStatusFn: "SetSiginStatusFn",
            SetLoadShowFn: "SetLoadShowFn",
            addLoadShowFn:"addLoadShowFn",
            FetchConfadlistFn:"FetchConfadlistFn"
        }),
        topscrollTo(e){
            this.$nextTick(() => {
                var that = document.getElementById("app").scrollTop;
                if (that > 80) {
                    this.isTop = true;
                } else {
                    this.isTop = false;
                }
            })
        },
        async scrollMoreMovies(){
            // if(this.isLoading || this.isEnd) return false;

            let clientH = document.documentElement.clientHeight || document.body.clientHeight;
            let scrollTop = Math.round
                (
                    document.getElementById("app").scrollTop
                ) || document.body.scrollTop;

            let sHeight = document.getElementById("app").scrollHeight || document.body.scrollHeight;

            if((scrollTop + clientH) - sHeight >= -50){
                if( this.isEnd == false) {
                this.isLoading = true;
                this.params.page++;
                const result = await this.FetchMobHomeMovieFn(
                    this.params
                );
                this.isLoading = false;

                if(!result.data){
                    this.isEnd = true;
                    this.params.page -= 1;
                    return;
                }

                if(result.data.list.length != this.params.pageSize) this.isEnd = true;
            }
            }
            this.SrcollListener();
        },
        linksToDetailHandler(mid, member_type){
            // this.SetCininfoStatusH5Fn(true);
            // window.localStorage.setItem("mid", id);

            // 发送统计上报
            const sendDataNikkatsuFn = async() => {
                const result = await this.getDataNikkatsuFn( {up_type: 6} );
            }
            sendDataNikkatsuFn();

            if(!window.localStorage.getItem("token")){
                window.localStorage.setItem('path', `/serial/${mid}?pid=${mid}`);
                this.SetSiginStatusFn(true);
                return;
            }
            if((Object.keys(this.userMember).length > 0 && this.userMember.isVip == 1) || member_type == 1) {
                this.SetLoadShowFn(false);
                this.addLoadShowFn(true).then(res => {
                this.$router.push('/serial/' + mid + '?pid=' + mid);
                })
            } else {
                this.$router.push("/member");
            }

        },
        // 监听滚动条距离,定位
        SrcollListener() {
            const floor_item = document.getElementsByClassName('h5_box');
            const window_scrollTop = document.getElementById("app").scrollTop || document.body.scrollTop;
            for (let i = 0, len = floor_item.length; i < len; i++) {
                let floor_offsetTop = floor_item[i].offsetTop - floor_item[0].offsetTop;
                if (window_scrollTop >= floor_offsetTop) {
                  this.tabIndex = i;
                  // setTimeout( async () => {
                  //   this.hsctrl == i;
                  // },3000);
                }
            }
        }
     },
    components: {
        WjsHeader,
        TopSwiper,
        CinemaList,
        CinemaDetail,
        CinemaHot,
        BarMovie,
        Servideo,
        midBar
    },
    watch: {
        async token(){
            if( this.token ){
                const hsParams = {page: 1, pageSize: 12};
                const hsResult = await this.FetchHomeSeenFn(hsParams);
            }
        },
        deep:true
    },
}
</script>
<style scoped>
::v-deep .header1 .navH5_bj{
    top: auto;
}
</style>
